import { TaskCenterTypes } from '@frontend/api-task-center';

export const getUpdatedFilters = (
  filters: Record<number, TaskCenterTypes.Filter>,
  taskFilters: Partial<TaskCenterTypes.Task>,
  locationId: string[]
): Record<number, TaskCenterTypes.Filter> => {
  if (taskFilters.source) {
    filters[TaskCenterTypes.FilterType_index.FILTER_BY_SOURCE] = { source: taskFilters.source, locationId };
  }
  if (taskFilters.sourceId) {
    filters[TaskCenterTypes.FilterType_index.FILTER_BY_SOURCE_ID] = { sourceId: [taskFilters.sourceId], locationId };
  }
  if (taskFilters.status) {
    filters[TaskCenterTypes.FilterType_index.FILTER_BY_STATUS] = { status: [taskFilters.status], locationId };
  }
  if (taskFilters.assignee) {
    filters[TaskCenterTypes.FilterType_index.FILTER_BY_ASSIGNEE] = { assignee: [taskFilters.assignee], locationId };
  }
  if (taskFilters.priority) {
    filters[TaskCenterTypes.FilterType_index.FILTER_BY_PRIORITY] = { priority: [taskFilters.priority], locationId };
  }
  return filters;
};
